import clientLayout from '@/layout/clientLayout.vue'
const clientRouter = {
  path: '/',
  component: clientLayout,
  children: [
    {
      path: '/',
      name: '首頁',
      component: () => import('@/client/home/index')
    },
	{
	  path: '/sea',
	  name: '海运查价',
	  component: () => import('@/client/home/checkPrice/Sea/index')
	},
	{
	  path: '/air',
	  name: '空运查价',
	  component: () => import('@/client/home/checkPrice/Air/index')
	},
	{
	  path: '/exp',
	  name: '快递查价',
	  component: () => import('@/client/home/checkPrice/Exp/index')
	},
	{
	  path: '/fba',
	  name: 'FBA查价',
	  component: () => import('@/client/home/checkPrice/Fba/index')
	},
    {
      path: '/order/exp',
      name: '快递下单',
      component: () => import('@/client/home/placeAnOrder/exp/index')
    },
    {
      path: '/order/fba',
      name: 'FBA下单',
      component: () => import('@/client/home/placeAnOrder/fba/index')
    },
    {
      path: '/order/air',
      name: '空运下单',
      component: () => import('@/client/home/placeAnOrder/air/index')
    },
    {
      path: '/order/sea',
      name: '海运下单',
      component: () => import('@/client/home/placeAnOrder/sea/index')
    }
  ]
}
export default clientRouter
